import useNavigation from 'core/hooks/useNavigation'
import cn from 'classnames'
import { docCookies } from 'utils/docCookies'
import useUrlIsAppRequest from 'core/hooks/useUrlIsAppRequest'
import FeatureIcon from 'core/components/icons/FeatureIcon'
import useTailwindBreakpoint from 'core/hooks/useTailwindBreakpoint'

const PublicTopNav = () => {
  const { pathname } = useNavigation()
  const isAppRequest = useUrlIsAppRequest()
  const { isMobile } = useTailwindBreakpoint()

  const reportUrlRegex = new RegExp(/(shared)/g)
  const isInSharedUrl = reportUrlRegex.test(pathname)
  const teamsSelfServe =
    pathname.includes('create-team') || pathname.includes('invite-members')
  const isAuthenticated = docCookies.hasItem('auth_token')
  const authUrlRegex = new RegExp(/auth/g)
  const isAuthPage = authUrlRegex.test(pathname)
  const onInvitePage = pathname?.includes('accept-invite')

  const logoLinkURL = isAuthPage
    ? 'https://everlance.com/'
    : 'https://everlance.com/business'
  const hrdText = isAuthPage
    ? 'Simplify mileage and expenses'
    : onInvitePage
      ? 'Automatic mileage & expense tracking'
      : 'Company Mileage & Expense Tracker'

  if (isAppRequest) return null

  return isInSharedUrl || teamsSelfServe || !isAuthenticated || onInvitePage ? (
    <div
      className={cn(
        'h-[4.6rem] py-2.5 px-5 bg-white shadow-md shadow-dark-1 flex items-center gap-6 cursor-pointer',
        isMobile ? 'justify-between' : ''
      )}
      onClick={() => window.open(logoLinkURL, '_blank')}
    >
      <span className="flex items-center gap-2 md:ml-5">
        <FeatureIcon name="everlance-logo" width={isMobile ? 110 : 160} />
      </span>
      <div
        className={cn('m-0 font-medium', isMobile ? 'text-right' : 'text-lg')}
      >
        {hrdText}
      </div>
    </div>
  ) : null
}

export default PublicTopNav
